import { sepAPI } from './API';
import { AISummaryResponse } from '../../shared/types/SepSummary';

export type { AISummaryResponse };

export const aiSummaryAPI = sepAPI.injectEndpoints({
  endpoints: (builder) => ({
    /** Reads the stored summary and refreshes it when SEP source data changed. */
    getSepAISummary: builder.query<AISummaryResponse, number>({
      query: (sepID) => ({
        url: `ai-summary/sep/${sepID}`,
        method: 'GET',
      }),
      providesTags: (result, error, sepID) => [{ type: 'AISummary', id: sepID }],
    }),
    regenerateSepAISummary: builder.mutation<AISummaryResponse, number>({
      query: (sepID) => ({
        url: `ai-summary/sep/${sepID}`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, sepID) => [{ type: 'AISummary', id: sepID }],
    }),
    updateSepAISummary: builder.mutation<
      AISummaryResponse,
      { sepID: number; summary: string }
    >({
      query: ({ sepID, summary }) => ({
        url: `ai-summary/sep/${sepID}`,
        method: 'PUT',
        body: { summary },
      }),
      invalidatesTags: (result, error, { sepID }) => [{ type: 'AISummary', id: sepID }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSepAISummaryQuery,
  useRegenerateSepAISummaryMutation,
  useUpdateSepAISummaryMutation,
} = aiSummaryAPI;
